import { useAsyncExecutor } from "async-executor-hook";
import { Paginator } from "primereact/paginator";
import { useState } from "react";

import {
  BodyContainerTableCommon,
  ContainerConfigurateCommon,
  ContainerGridColumnsTableCommon,
  ContainerScrollCommon,
  TableHeaderCommonResponsive,
} from "../../common/components/TableResponsive";
import { getErrorValueResponse } from "../../common/error/Error";
import IconWarning from "../../images/icon_warning.svg";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { LOADING_SIZE_RUCS } from "../../utils/valueStaticConstants";
import {
  DivBodyRuc,
  DivHeaderRuc,
  RucsButton,
  RucsContainer,
} from "../AdditionalVolanteModal/AdditionalRucsModalStyles";
import Modal from "../Modal/Modal";
import PaymentLoader from "../PaymentLoader/PaymentLoader";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import { DivPaginatorButton, PaginatorModal } from "./CreditMethodStyles";
import CreditThirdMethodSearch from "./CreditThirdMethodSearch";

export const CreditThirdMethod = (props) => {
  const {
    onOutsideClick,
    setShowUploadDocument,
    updateSelectedRuc,
    selectedRuc,
    payerItems,
    updateShowModal,
    setShowModalThirdError,
    setMessageErrorThird,
  } = props;
  const getCreditThirdData = useAsyncExecutor(
    (params: any) => {
      const { data } = params;
      const excluded_rucs = params.payerItems
        .map((payerItem) => payerItem.payerRuc)
        .filter((e) => e !== "");

      const paramsGeneral = {
        excluded_rucs,
        has_credit_line: true,
        page_size: 5,
        page: params.page ?? 1,
      };
      if (params.dataSearch) {
        if (params.dataSearch.type_option === "r_s") {
          const paramsUpdateRS = {
            ...paramsGeneral,
            billable_ruc_name: params.dataSearch.billable_ruc_name,
          };
          return networkBackendRequest(
            `/billable-rucs/`,
            HTTP_METHODS.GET,
            paramsUpdateRS
          ).then((response) => response.json());
        } else if (params.dataSearch.type_option === "ruc") {
          const paramsUpdateRuc = {
            ...paramsGeneral,
            billable_ruc: params.dataSearch.billable_ruc,
          };
          return networkBackendRequest(
            `/billable-rucs/`,
            HTTP_METHODS.GET,
            paramsUpdateRuc
          ).then((response) => response.json());
        }
      }

      if (data.type_option === "r_s") {
        const paramsRS = {
          ...paramsGeneral,
          billable_ruc_name: data.billable_ruc_name,
        };
        return networkBackendRequest(
          `/billable-rucs/`,
          HTTP_METHODS.GET,
          paramsRS
        ).then((response) => response.json());
      }

      if (data.type_option === "ruc") {
        const paramsRuc = {
          ...paramsGeneral,
          billable_ruc: data.billable_ruc,
        };
        return networkBackendRequest(
          `/billable-rucs/`,
          HTTP_METHODS.GET,
          paramsRuc
        ).then((response) => response.json());
      }
    },
    {
      onError: (error) => {
        const errorMessage = getErrorValueResponse(error);
        setMessageErrorThird(errorMessage);
        setShowModalThirdError(true);
        updateShowModal(false);
      },
    }
  );

  const [isChecked, setIsChecked] = useState(false);
  const [dataSearch, setDataSearch] = useState();
  const GRID_TEMPLATE_COLUMNS = "4rem 1.5fr 1fr";
  return (
    <Modal onOutsideClick={onOutsideClick}>
      <RucsContainer width="auto">
        <h1 className="spacing">USO CRÉDITO DE TERCEROS</h1>
        <CreditThirdMethodSearch
          getCreditThirdData={getCreditThirdData}
          payerItems={payerItems}
          setDataSearch={setDataSearch}
        />
        {getCreditThirdData.isSuccess &&
          getCreditThirdData.data.billable_rucs.length === 0 && (
            <StandaloneMessage>
              No se encontraron parámetros de crédito a otros.
            </StandaloneMessage>
          )}
        <div
          style={{ width: "100%", marginLeft: "4.2rem", marginRight: "4.2rem" }}
        >
          {getCreditThirdData.status === "PROCESSING" && (
            <div
              style={{
                marginRight: "2rem",
                marginLeft: "2rem",
                background: "#F6F6FD",
              }}
            >
              <PaymentLoader numItems={LOADING_SIZE_RUCS} />
            </div>
          )}
          <ContainerScrollCommon>
            <ContainerConfigurateCommon>
              <ContainerGridColumnsTableCommon
                gridTemplateColumns={GRID_TEMPLATE_COLUMNS}
              >
                {getCreditThirdData.isSuccess &&
                  getCreditThirdData.data.billable_rucs.length > 0 && (
                    <TableHeaderCommonResponsive className="item-container">
                      <div
                        className="main-info-header"
                        style={{ marginLeft: "2rem" }}
                      ></div>
                      <DivHeaderRuc marginLeft="1.5rem">
                        RUC/RAZÓN SOCIAL
                      </DivHeaderRuc>
                      <DivHeaderRuc>DIRECCIÓN/DISTRITO</DivHeaderRuc>
                    </TableHeaderCommonResponsive>
                  )}
                <div
                  style={{
                    overflowY: "scroll",
                    maxHeight: "60vh",
                    background: "#F6F6FD",
                  }}
                  className="scroll"
                >
                  {getCreditThirdData.isSuccess &&
                    getCreditThirdData.data.billable_rucs.map((ruc) => {
                      return (
                        <div key={ruc.billable_ruc}>
                          <BodyContainerTableCommon
                            className="item-container"
                            height="auto"
                            padding="1.8rem 1.5rem"
                          >
                            <div
                              className="attribute"
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                              }}
                            >
                              <div className="titles"></div>
                              <input
                                style={{ cursor: "pointer" }}
                                className="checkInvoice clickable-element"
                                type="checkbox"
                                checked={
                                  ruc.billable_ruc === selectedRuc && isChecked
                                }
                                onChange={(e) => {
                                  updateSelectedRuc(ruc.billable_ruc);
                                  setIsChecked(e.target.checked);
                                }}
                              />
                            </div>
                            <DivBodyRuc className="attribute">
                              <div className="titles">RUC/RAZÓN SOCIAL</div>
                              <DivBodyRuc className="left-align">
                                <div className="ruc-id">{ruc.billable_ruc}</div>
                                <div>{ruc.billable_ruc_name}</div>
                              </DivBodyRuc>
                            </DivBodyRuc>
                            <DivBodyRuc className="attribute">
                              <div className="titles">DIRECCIÓN/DISTRITO</div>
                              <DivBodyRuc className="left-align">
                                <div>{ruc.billable_address}</div>
                                <div className="ruc-id">{ruc.district}</div>
                              </DivBodyRuc>
                            </DivBodyRuc>
                          </BodyContainerTableCommon>
                        </div>
                      );
                    })}
                </div>
              </ContainerGridColumnsTableCommon>
            </ContainerConfigurateCommon>
          </ContainerScrollCommon>
        </div>

        <>
          <div className="warning-message">
            <img src={IconWarning} alt="warning" />
            <p>
              Necesita adjuntar un documento para poder autorizar la facturación
              con un RUC de terceros.
            </p>
          </div>
          <DivPaginatorButton justifyContent={getCreditThirdData.isSuccess}>
            {getCreditThirdData.isSuccess &&
              getCreditThirdData.data.billable_rucs.length > 0 && (
                <div className="right-align spacing">
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <PaginatorModal>
                      <Paginator
                        className="class-paginator-color-f"
                        first={
                          (getCreditThirdData.data.page - 1) *
                          getCreditThirdData.data.page_size
                        }
                        rows={getCreditThirdData.data.page_size}
                        totalRecords={getCreditThirdData.data.count}
                        onPageChange={(e) => {
                          const targetPage =
                            e.first / getCreditThirdData.data.page_size;
                          getCreditThirdData.execute({
                            page: targetPage + 1,
                            payerItems,
                            dataSearch,
                          });
                        }}
                      />
                    </PaginatorModal>
                  </div>
                </div>
              )}
            <RucsButton
              onClick={() => {
                setShowUploadDocument(true);
              }}
              disabled={
                (getCreditThirdData.isSuccess &&
                  getCreditThirdData.data.billable_rucs.length === 0) ||
                !selectedRuc ||
                !isChecked
              }
            >
              Adjuntar documento
            </RucsButton>
          </DivPaginatorButton>
        </>
      </RucsContainer>
    </Modal>
  );
};
